import type { Theme } from "../types";

/** OpenStatus Infinite theme (Data-table filters) */
export const bundle05: Theme[] = [
  {
    colors: {
      accent: "#f1f5f9",
      accentForeground: "#0f172a",
      background: "#ffffff",
      border: "#e2e8f0",
      card: "#ffffff",
      cardForeground: "#020817",
      chartColors: ["#e76e50", "#2a9d90", "#274754", "#e8c468", "#f4a462"],
      destructive: "#ef4444",
      foreground: "#020817",
      input: "#e2e8f0",
      muted: "#f1f5f9",
      mutedForeground: "#64748b",
      popover: "#ffffff",
      popoverForeground: "#020817",
      primary: "#0f172a",
      primaryForeground: "#f8fafc",
      ring: "#020817",
      secondary: "#f1f5f9",
      secondaryForeground: "#0f172a",
      sidebar: "#fafafa",
      sidebarAccent: "#f4f4f5",
      sidebarAccentForeground: "#18181b",
      sidebarBorder: "#e5e7eb",
      sidebarForeground: "#3f3f46",
      sidebarPrimary: "#18181b",
      sidebarPrimaryForeground: "#fafafa",
      sidebarRing: "#3b82f6",
    },
    isDark: false,
    label: "OpenStatus Infinite",
    name: "openstatus-infinite-light",
    pair: "openstatus-infinite-dark",
    swatches: ["#ffffff", "#3b82f6", "#f1f5f9", "#e76e50"],
  },
  {
    colors: {
      accent: "#1e293b",
      accentForeground: "#f8fafc",
      background: "#020817",
      border: "#1e293b",
      card: "#020817",
      cardForeground: "#f8fafc",
      chartColors: ["#2662d9", "#2eb88a", "#e88c30", "#af57db", "#e23670"],
      destructive: "#7f1d1d",
      foreground: "#f8fafc",
      input: "#1e293b",
      muted: "#1e293b",
      mutedForeground: "#94a3b8",
      popover: "#020817",
      popoverForeground: "#f8fafc",
      primary: "#f8fafc",
      primaryForeground: "#0f172a",
      ring: "#cbd5e1",
      secondary: "#1e293b",
      secondaryForeground: "#f8fafc",
      sidebar: "#18181b",
      sidebarAccent: "#27272a",
      sidebarAccentForeground: "#f4f4f5",
      sidebarBorder: "#27272a",
      sidebarForeground: "#f4f4f5",
      sidebarPrimary: "#1d4ed8",
      sidebarPrimaryForeground: "#fff",
      sidebarRing: "#3b82f6",
    },
    isDark: true,
    label: "OpenStatus Infinite",
    name: "openstatus-infinite-dark",
    pair: "openstatus-infinite-light",
    swatches: ["#020817", "#3b82f6", "#1e293b", "#2662d9"],
  },
];
